import { Directive, ElementRef, Input } from "@angular/core";

@Directive({
  standalone: true,
  selector: '[dataSelectId]'
})
export class DataSelectIdDirective {
  @Input('data-select-id') dataSelectId!: string;

  constructor(public elementRef: ElementRef) {}
}